<template>
  <div class="flex align-center inline-checkbox-outer">
    <!-- <div :class="{ 'input--checked': isChecked, 'input--checkbox': true }" v-on:click="toggle"></div> -->
    <input type="radio" :name="group" ref="radio" v-model="value">

    <label class="input__inline-label" v-on:click="toggle">
      {{ label }} <span v-if="required" class="input__asterisk">*</span>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'inputRadio',
    props: [
      'label',
      'required',
      'value',
      'model',
      'group'
    ],
    data () {
      return {
        isChecked: !!this.value
      }
    },
    methods: {
      change () {
        this.$emit('input', this.model)
      },
      toggle () {
        this.isChecked = !this.isChecked
        this.change()
      }
    },
    mounted () {

    }
  }
</script>



// WEBPACK FOOTER //
// inputRadio.vue?7345cf1b